import { Link } from "react-router-dom";
import { newsList } from "@/mocks/news";

export default function LatestNews() {
  const items = newsList.slice(0, 5);

  return (
    <div className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
      {items.map((item, i) => (
        <Link
          key={item.id}
          to={`/news/${item.id}`}
          className={`group flex items-start gap-4 p-4 transition-colors hover:bg-background-100 md:p-5 ${
            i !== 0 ? "border-t border-background-200" : ""
          }`}
        >
          <div className="hidden h-16 w-24 shrink-0 overflow-hidden rounded-md bg-background-200 sm:block">
            <img
              src={item.cover}
              alt={item.title}
              title={`${item.title} - 91看片影视资讯`}
              className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
          </div>
          <div className="min-w-0 flex-1">
            <div className="flex items-center gap-2 text-xs text-foreground-400">
              <span className="flex items-center gap-1">
                <i className="ri-calendar-line"></i>
                {item.date}
              </span>
              <span className="rounded bg-accent-100 px-1.5 py-0.5 text-[11px] text-accent-800">
                {item.tags[0]}
              </span>
            </div>
            <h3 className="mt-1.5 line-clamp-2 text-sm font-semibold text-foreground-950 transition-colors group-hover:text-primary-700 md:text-base">
              {item.title}
            </h3>
            <p className="mt-1 line-clamp-2 hidden text-xs text-foreground-500 sm:block">
              {item.summary}
            </p>
          </div>
          <i className="ri-arrow-right-s-line mt-1 hidden shrink-0 text-xl text-foreground-300 transition-colors group-hover:text-accent-500 md:block"></i>
        </Link>
      ))}
    </div>
  );
}